/* soundcite - v0.4.1 - 2015-05-11
 * Copyright (c) 2015 Tyler J. Fisher and Northwestern University Knight Lab
 */
//loop branch
// window.Popcorn.version = 1.5.6
// http://cdn.popcornjs.org/code/dist/popcorn.min.js
// window.SC._version = 2.0.0
// http://connect.soundcloud.com/sdk-2.0.0.js

(function(window, document) {
  // http://stackoverflow.com/questions/2170439/how-to-embed-javascript-widget-that-depends-on-jquery-into-an-unknown-environmen

  var SOUNDCITE_CONFIG = {
    update_playing_element: function(el, percentage, color) {
      var c1 = 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + 0.2 * color.a + ')',
        c2 = 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + 0.1 * color.a + ')';

      el.style.cssText +=
        'background: -webkit-linear-gradient(left, ' +
        c1 +
        percentage +
        '%, ' +
        c2 +
        (percentage + 0.1) +
        '%);' +
        'background: linear-gradient(to right, ' +
        c1 +
        percentage +
        '%, ' +
        c2 +
        (percentage + 0.1) +
        '%);';
    },
  };

  for (var key in window.SOUNDCITE_CONFIG) {
    SOUNDCITE_CONFIG[key] = window.SOUNDCITE_CONFIG[key];
  }

  // global vars
  var soundcite = (window.soundcite = {});

  // check for mobile
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    soundcite.mobile = true;
  } else {
    soundcite.mobile = false;
  }

  // document.head not standard before HTML5
  var insertionPoint =
      document.head || document.getElementsByTagName('head').item(0) || document.documentElement.childNodes[0],
    clips = [],
    $SoundCloud,
    $Popcorn,
    soundCloudState = 'none',
    popcornState = 'none',
    soundCloudQueue = [],
    popcornQueue = [];

  function getElColor(el) {
    var color = {
      r: 0,
      g: 0,
      b: 0,
      a: 1,
    };

    if (document.defaultView && document.defaultView.getComputedStyle) {
      var compStyle = document.defaultView.getComputedStyle(el, null);
      if (compStyle) {
        var val = compStyle.getPropertyValue('color').toLowerCase(),
          rgb = /\s*rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)\s*/,
          rgba = /\s*rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d+|\d*\.\d+)\s*\)\s*/,
          m = val.match(rgb) || val.match(rgba);

        if (m) {
          color = {
            r: m[1] - 0,
            g: m[2] - 0,
            b: m[3] - 0,
            a: m[4] !== undefined ? m[4] - 0 : 1,
          };
        } else {
          val = val.replace('#', '');
          color = {
            r: parseInt(val.substring(0, 2), 16),
            g: parseInt(val.substring(2, 4), 16),
            b: parseInt(val.substring(4, 6), 16),
            a: 1,
          };
        }
      }
    }

    return color;
  }

  // borrowing underscore.js bind function
  var bind = function(func, context) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 2);
    return function() {
      return func.apply(context, args.concat(slice.call(arguments)));
    };
  };

  function cmp_vers(v1, v2) {
    var a1 = v1.split('.');
    var a2 = v2.split('.');
    for (var i = 0; i < Math.min(a1.length, a2.length); i++) {
      var n1 = parseInt(a1[i]);
      var n2 = parseInt(a2[i]);
      var d = n1 - n2;
      if (d) {
        return d;
      }
    }
    return a1.length - a2.length;
  }

  function load_popcorn(version, cb) {
    var js = window.Popcorn,
      d,
      new_js;

    popcornState = 'loading';

    if (!js || cmp_vers(version, js.version) > 0 || cb(js, (popcornState = 'loaded'))) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `${RM_PUBLIC_PATH}js/libs/popcorn.min.js`; // no SSL version of this, will self-host
      script.onload = script.onreadystatechange = function() {
        if (popcornState == 'loading' && (!(d = this.readyState) || d == 'loaded' || d == 'complete')) {
          new_js = window.Popcorn;
          if (js) {
            window.Popcorn = js;
          }
          cb(new_js, (popcornState = 'loaded'));
          insertionPoint.removeChild(script);
        }
      };
      insertionPoint.appendChild(script);
    }
  }

  // Loading player api initializes incomplete version of window.SC
  function load_soundcloud(version, cb) {
    var js = window.SC,
      d;

    soundCloudState = 'loading';

    if (!js || !js.Dialog || cmp_vers(version, js._version) > 0 || cb(js, (soundCloudState = 'loaded'))) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//connect.soundcloud.com/sdk-2.0.0.js';
      script.onload = script.onreadystatechange = function() {
        if (soundCloudState == 'loading' && (!(d = this.readyState) || d == 'loaded' || d == 'complete')) {
          cb(window.SC, (soundCloudState = 'loaded'));
          insertionPoint.removeChild(script);
        }
      };
      insertionPoint.appendChild(script);
    }
  }

  function removeClass(el, name) {
    var cn = el.className;
    for (var i = 0, arr = name.match(/\S+/g); i < arr.length; i++) {
      cn = cn.replace(new RegExp('(?:^|\\s)' + arr[i] + '(?!\\S)'), '');
    }
    el.className = cn;
  }

  function addClass(el, name) {
    var cn = el.className;
    for (var i = 0, arr = name.match(/\S+/g); i < arr.length; i++) {
      if (!cn.match(new RegExp('(?:^|\\s)' + arr[i] + '(?!\\S)'))) {
        cn += ' ' + arr[i];
      }
    }
    el.className = cn;
  }

  // pause all playing clips. Optionally pass a clip as an argument which
  // should not be paused, for the case that this is triggered from a
  // click handler.
  function pause_all_clips(except_clip) {
    for (var i = 0; i < clips.length; i++) {
      if (clips[i].playing) {
        if (!except_clip || except_clip.el !== clips[i].el) {
          clips[i].pause();
        }
      }
    }
  }

  // Clip
  function Clip(el) {
    this.el = el;
    this.start = el.hasAttribute('data-start') ? el.getAttribute('data-start') : 0; // ms
    this.end = el.hasAttribute('data-end') ? el.getAttribute('data-end') : null; // ms

    this.plays = el.hasAttribute('data-plays') ? parseInt(el.getAttribute('data-plays')) : 1;
    this.plays_left = this.plays;

    this.playing = false;
    this.sound = null; // implement in subclass

    this.click_handler_binded = bind(this.click_handler, this);

    clips.push(this); // keep track of this
  }

  //RFC4122 version 4 compliant solution
  //offsetting the first 13 hex numbers by a hex portion of the timestamp
  //in case of Math.random is on the same seed
  Clip.prototype.generateUUID = function() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  };

  Clip.prototype.sound_loaded = function() {
    this.el.addEventListener('click', this.click_handler_binded);
    removeClass(this.el, 'soundcite-initializing');

    //хак для iOS чтобы прекратил анимацию прелоадера, а то у него бывает остаточное торможение и он начинает крутить ненадолго уже кнопку play
    this.el.style.display = 'none';
    this.el.offsetHeight; // no need to store this anywhere, the reference is enough
    this.el.style.display = '';

    addClass(this.el, 'soundcite-loaded soundcite-play');
  };

  Clip.prototype.pause = function() {
    removeClass(this.el, 'soundcite-pause');
    addClass(this.el, 'soundcite-play');
    this.playing = false;
    this.pause_sound(); // implement in subclass
  };

  Clip.prototype.stop = function() {
    removeClass(this.el, 'soundcite-pause');
    addClass(this.el, 'soundcite-play');
    this.playing = false;
    this.plays_left = this.plays; // reset plays_left!
    this.stop_sound(); // implement in subclass
  };

  Clip.prototype.track_progress = function() {
    var totalTime = this.end - this.start;
    var position = this.sound_position(); // implement in subclass
    var relative_position = position - this.start;
    var percentage = (relative_position * 100) / totalTime;

    if (!this.color) {
      this.color = getElColor(this.el);
    }
    SOUNDCITE_CONFIG.update_playing_element(this.el, percentage, this.color);
  };

  Clip.prototype.click_handler = function(event) {
    event.preventDefault(); // if used on a tag, don't follow href
    pause_all_clips(this);
    if (this.playing) {
      this.pause();
    } else {
      this.play(); // implement in subclass
    }
  };

  Clip.prototype.destroy = function(event) {
    this.destroyed = true;

    this.playing && this.pause();

    this.el &&
      removeClass(this.el, 'soundcite-loaded soundcite-initializing soundcite-loading soundcite-play soundcite-pause');

    this.el && this.el.removeEventListener('click', this.click_handler_binded);
  };

  // SoundCloudClip
  function SoundCloudClip(el) {
    Clip.apply(this, Array.prototype.slice.call(arguments));

    this.id = el.getAttribute('data-id');

    // initialize SoundCloud SDK
    if (soundCloudState !== 'initialized') {
      $SoundCloud.initialize({
        client_id: '5ba7fd66044a60db41a97cb9d924996a',
      });

      soundCloudState = 'initialized';
    }

    $SoundCloud.stream(
      this.id,
      bind(function(sound) {
        if (this.destroyed) {
          sound._player.kill && sound._player.kill();
          return;
        }

        this.sound = sound;

        this.sound._player.on(
          'positionChange',
          bind(function(pos) {
            this.track_progress();

            if (!this.playing) return; //иногда timeupdate выстреливает после стопа, и идет бесконечный цикл

            if (pos < this.start) {
              //на ios код в 	SoundCloudClip.prototype.play не отрабатывает и воспроизведение начинает сначала, а не откуда надо, видимо из-за дозагрузки, поэтому постоянно проверяем что мы находимся после начала
              this.sound.seek(this.start);
            }

            //на ios баг при повторном запуске после окончания цикла, звука нет, а positionChange выстреливает одно и то же значение
            //upd. закоментил, так делать нельзя
            //если start выставлен очень далеко, то этот код начинает срабатывать даже при первом старте, и в итоге проигрывания вообще нет
            /*if (pos == this.prevPos && pos == this.start) {
					this.pause();
					this.play();
					return;
				}*/

            if (pos >= this.end) {
              if (this.plays) {
                this.plays_left--; // update plays_left
                if (this.plays_left > 0) {
                  this.play();
                } else {
                  this.stop();
                }
              } else {
                // infinite loop
                this.play();
              }
              this.track_progress();
            }

            this.prevPos = pos;
          }, this)
        );

        if (this.end === null) {
          this.end = this.sound.getDuration();
        }

        this.sound_loaded();
      }, this)
    );
  }
  SoundCloudClip.prototype = Object.create(Clip.prototype);

  SoundCloudClip.prototype.sound_position = function() {
    return this.sound.getCurrentPosition();
  };

  SoundCloudClip.prototype.pause_sound = function() {
    this.sound.pause();
  };

  SoundCloudClip.prototype.stop_sound = function() {
    this.sound.stop();
  };

  SoundCloudClip.prototype.play = function() {
    var pos = this.sound_position();

    if (pos < this.start || pos >= this.end) {
      this.sound.seek(this.start);
    }

    removeClass(this.el, 'soundcite-play');
    addClass(this.el, 'soundcite-pause');

    this.sound.play();
    this.playing = true;
    this.prevPos = -1;
  };

  SoundCloudClip.prototype.destroy = function() {
    this.sound && this.sound._player.kill && this.sound._player.kill();

    Clip.prototype.destroy.apply(this, arguments);
  };

  // Popcorn Clip
  function PopcornClip(el) {
    Clip.apply(this, Array.prototype.slice.call(arguments));

    this.id = 'soundcite-audio-' + this.generateUUID();
    this.url = el.getAttribute('data-url');

    // convert to ms to secs
    this.start = Math.floor(this.start / 1000);
    if (this.end !== null) {
      this.end = Math.floor(this.end / 1000);
    }

    if (popcornState != 'initialized') {
      // setup audio container
      soundcite.audio_container = document.createElement('div');
      addClass(soundcite.audio_container, 'soundcite-audio');
      document.getElementsByTagName('body')[0].appendChild(soundcite.audio_container);

      popcornState = 'initialized';
    }

    this.audio = document.createElement('audio');
    this.audio.id = this.id;
    this.audio.setAttribute('src', this.url);

    //запрещаем прелоадинг и делаем вид что мы всегда с мобильного, чтобы не было никакой предзагрузки
    this.audio.setAttribute('preload', 'none');
    soundcite.mobile = true;

    soundcite.audio_container.appendChild(this.audio);

    this.sound = $Popcorn('#' + this.id, { frameAnimation: true });

    // Safari iOS Audio streams cannot be loaded unless triggered by a
    // user event, so load in play_sound via click for mobile
    this.sound.on(
      'loadeddata',
      bind(function() {
        if (this.end === null) {
          this.end = this.sound.duration();
        }

        if (!soundcite.mobile) {
          this.sound_loaded();
        }
      }, this)
    );

    if (soundcite.mobile) {
      this.sound_loaded();
    } else if (this.sound.readyState() > 1) {
      this.sound_loaded();
    }
  }
  PopcornClip.prototype = Object.create(Clip.prototype);

  PopcornClip.prototype.sound_position = function() {
    return this.sound.currentTime();
  };

  PopcornClip.prototype.pause_sound = function() {
    this.sound.pause();
    this.sound.off('timeupdate');
  };

  PopcornClip.prototype.stop_sound = function() {
    this.sound.off('timeupdate');
    this.sound.pause();
  };

  PopcornClip.prototype._play_sound = function() {
    removeClass(this.el, 'soundcite-loading soundcite-play');
    addClass(this.el, 'soundcite-pause');

    this.sound.play();
    this.playing = true;

    this.sound.on(
      'timeupdate',
      bind(function() {
        this.track_progress();

        if (!this.playing) return; //иногда timeupdate выстреливает после стопа, и идет бесконечный цикл

        if (this.sound.currentTime() >= this.end) {
          if (this.plays) {
            this.plays_left--; // update plays_left
            if (this.plays_left > 0) {
              this.play_sound();
            } else {
              this.stop();
            }
          } else {
            // infinite loop
            this.play_sound();
          }
          this.track_progress();
        }
      }, this)
    );
  };

  PopcornClip.prototype.play_sound = function() {
    var pos = this.sound.currentTime();

    if (pos < this.start || pos >= this.end) {
      this.sound.on(
        'seeked',
        bind(function() {
          this.sound.off('seeked');
          this._play_sound();
        }, this)
      );

      this.sound.currentTime(this.start);
    } else {
      this._play_sound();
    }
  };

  PopcornClip.prototype.play = function() {
    if (/soundcite\-loading/.test(this.el.className)) return;

    if (soundcite.mobile) {
      removeClass(this.el, 'soundcite-play');
      addClass(this.el, 'soundcite-loading');

      if (this.startedLoading) {
        this.play_sound();
      } else {
        this.sound.on(
          'canplaythrough',
          bind(function() {
            this.play_sound();
          }, this)
        );
        document.getElementById(this.id).load();
      }
      this.startedLoading = true;
    } else {
      this.play_sound();
    }
  };

  PopcornClip.prototype.destroy = function() {
    this.sound && $Popcorn.destroy(this.sound); //Stops the instance’s timeUpdate loop and removes any associated events.

    this.audio && soundcite.audio_container.removeChild(this.audio);

    Clip.prototype.destroy.apply(this, arguments);
  };

  soundcite.createPlayer = function(el) {
    addClass(el, 'soundcite-initializing');

    //принудительно устанавливаем цвет фона плеера
    //это связано с багом в ios и сафари
    //currentColor has a bug on iOS and pseudo-elements
    //http://stackoverflow.com/questions/29400291/currentcolor-seems-to-get-stuck-in-safari
    addClass(el, 'soundcite-force-bg-color');
    SOUNDCITE_CONFIG.update_playing_element(el, 0, getElColor(el));

    //Popcorn
    if (el.getAttribute('data-url')) {
      if (popcornState == 'none') {
        popcornQueue.push(el);

        load_popcorn('1.5.6', function(js) {
          $Popcorn = js;
          for (var i = 0; i < popcornQueue.length; i++) {
            new PopcornClip(popcornQueue[i]);
          }
        });
      } else if (popcornState == 'loading') {
        popcornQueue.push(el);
      } else {
        //loaded, initialized
        new PopcornClip(el);
      }
    }

    //SoundCloud
    if (el.getAttribute('data-id')) {
      if (soundCloudState == 'none') {
        soundCloudQueue.push(el);

        load_soundcloud('2.0.0', function(js) {
          $SoundCloud = js;
          for (var i = 0; i < soundCloudQueue.length; i++) {
            new SoundCloudClip(soundCloudQueue[i]);
          }
        });
      } else if (soundCloudState == 'loading') {
        soundCloudQueue.push(el);
      } else {
        //loaded, initialized
        new SoundCloudClip(el);
      }
    }
  };

  soundcite.destroyPlayer = function(el) {
    for (var i = clips.length - 1; i >= 0; i--) {
      if (clips[i].el == el) {
        clips[i].destroy();
        clips.splice(i, 1);
      }
    }

    for (var i = popcornQueue.length - 1; i >= 0; i--) {
      if (popcornQueue[i] == el) {
        popcornQueue.splice(i, 1);
      }
    }

    for (var i = soundCloudQueue.length - 1; i >= 0; i--) {
      if (soundCloudQueue[i] == el) {
        soundCloudQueue.splice(i, 1);
      }
    }
  };

  soundcite.pausePlayer = function(el) {
    for (var i = 0; i < clips.length; i++) {
      if (el == clips[i].el && clips[i].playing) {
        clips[i].pause();
      }
    }
  };

  soundcite.setElementsColor = function(el) {
    SOUNDCITE_CONFIG.update_playing_element(el, 0, getElColor(el));
  };
})(window, document);
